import type { TPlatform } from '@shared/types/platform.types';
import { useQuery } from '@tanstack/react-query';
import { api } from 'src/app/api/base';
import { URL_COMPUTERS } from 'src/app/api/urls';
import { AndroidDeviceDetailRootSchema } from 'src/schemas/device/android-device-detail.schema';
import { AppleDeviceDetailRootSchema } from 'src/schemas/device/apple-device-detail.schema';
import { WindowsDeviceDetailRootSchema } from 'src/schemas/device/windows-device-detail.schema';
import type { IDeviceDetail } from './common';

export const useGetDeviceDetails = (
  deviceId: string,
  platform: TPlatform = 'Apple',
) =>
  useQuery({
    queryKey: ['device-details', deviceId],
    queryFn: async (): Promise<IDeviceDetail> => {
      const apiRes = await api(`${URL_COMPUTERS}${deviceId}/details`).get({});

      const res = apiRes.data;
      const details = platform === 'Android' ? res : res.details;

      const schema = {
        Windows: WindowsDeviceDetailRootSchema,
        Android: AndroidDeviceDetailRootSchema,
        Apple: AppleDeviceDetailRootSchema,
      };

      const { data, success, error } = schema[platform]
        .partial()
        .safeParse(details);

      if (!success) {
        console.error(
          `Failed to translate complete device detail: ${JSON.stringify(
            error.errors,
          )}}`,
        );
      }

      return data as IDeviceDetail;
    },
  });
